<div id="kl-design-preference-dynamic" class="kl-design-preference-dynamic__body">
  @if (loadingMeta()) {
    <div class="kl-design-preference-dynamic__loading d-flex align-items-center justify-content-center">
      <kl-loader />
    </div>
  } @else {
    @if (errorShow) {
      <kl-alert
        [show]="true"
        type="error"
        [message]="'required_fields_must_be_entered' | translate"
        [showClose]="true"
        (onClose)="errorShow = false" />
    }

    <div class="kl-design-preference-dynamic__row">
      <label class="kl-design-preference-dynamic__label" for="designEntryName">
        {{ nameLabelKey() | translate }}
        <span class="text-danger">*</span>
      </label>
      <div class="kl-design-preference-dynamic__control">
        <input
          pInputText
          id="designEntryName"
          class="w-100"
          [(ngModel)]="entryName"
          name="designEntryName"
          maxlength="120" />
      </div>
    </div>

    @if (showRoleAndUsers()) {
      <div class="kl-design-preference-dynamic__row kl-design-preference-dynamic__row--align-start">
        <span
          class="kl-design-preference-dynamic__label kl-design-preference-dynamic__label--empty"
          aria-hidden="true"></span>
        <div class="kl-design-preference-dynamic__control kl-design-preference-dynamic__radios">
          <div class="d-flex flex-column gap-2">
            <div class="d-flex align-items-center gap-2">
              <p-radioButton inputId="ltUser" name="levelType" value="user" [(ngModel)]="levelType" />
              <label for="ltUser" class="mb-0">{{ 'user' | translate }}</label>
            </div>
            <div class="d-flex align-items-center gap-2">
              <p-radioButton inputId="ltRole" name="levelType" value="role" [(ngModel)]="levelType" />
              <label for="ltRole" class="mb-0">{{ 'user_roles' | translate }}</label>
            </div>
          </div>
        </div>
      </div>

      @if (levelType === 'user') {
        <div class="kl-design-preference-dynamic__row kl-design-preference-dynamic__row--align-start">
          <span
            class="kl-design-preference-dynamic__label kl-design-preference-dynamic__label--empty"
            aria-hidden="true"></span>
          <div class="kl-design-preference-dynamic__control">
            <p-multiselect
              [options]="userList()"
              [(ngModel)]="selectedUsers"
              optionLabel="username"
              dataKey="id"
              [filter]="true"
              [resetFilterOnHide]="true"
              display="comma"
              appendTo="body"
              [overlayOptions]="{ baseZIndex: 12000 }"
              [placeholder]="'all_user' | translate"
              [emptyMessage]="'not_found' | translate"
              inputId="selectedUsers"
              name="selectedUsers"
              class="w-100" />
          </div>
        </div>
      } @else {
        <div class="kl-design-preference-dynamic__row kl-design-preference-dynamic__row--align-start">
          <span
            class="kl-design-preference-dynamic__label kl-design-preference-dynamic__label--empty"
            aria-hidden="true"></span>
          <div class="kl-design-preference-dynamic__control">
            <p-multiselect
              [options]="roleList()"
              [(ngModel)]="selectedRoles"
              optionLabel="description"
              dataKey="id"
              [filter]="true"
              [resetFilterOnHide]="true"
              display="comma"
              appendTo="body"
              [overlayOptions]="{ baseZIndex: 12000 }"
              [placeholder]="'all_roles' | translate"
              [emptyMessage]="'not_found' | translate"
              inputId="selectedRoles"
              name="selectedRoles"
              class="w-100" />
          </div>
        </div>
      }
    }

    <div class="kl-design-preference-dynamic__row">
      <span
        class="kl-design-preference-dynamic__label kl-design-preference-dynamic__label--empty"
        aria-hidden="true"></span>
      <div class="kl-design-preference-dynamic__control d-flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="levelDesign" [binary]="true" inputId="levelDesignCb" name="levelDesignCb" />
        <label for="levelDesignCb" class="mb-0">{{ 'save_as_default' | translate }}</label>
      </div>
    </div>
  }

  <div class="kl-design-preference-dynamic__footer">
    <p-button
      size="small"
      [label]="commitType() === 'edit' ? ('edit' | translate) : ('save' | translate)"
      severity="primary"
      [loading]="saving()"
      [disabled]="loadingMeta() || saving()"
      (onClick)="confirm()" />
    <p-button
      size="small"
      [label]="'cancel' | translate"
      severity="secondary"
      [outlined]="true"
      [disabled]="saving()"
      (onClick)="cancel()" />
  </div>
</div>
